export default __webpack_public_path__ + "static/The Adventure_image 6@2x-b6aef2a26edfb0b9517734185d23e41c.jpg";